
export const PUSH_NOTIFICATION_DATA = 'PUSH_NOTIFICATION_DATA';
export const POP_NOTIFICATION_DATA = 'POP_NOTIFICATION_DATA';